/**
 * BMB SeptemberSpring Theme - Interactive Luxury Engine
 * Handles Mobile Sticky Bar, Free Shipping Calculations & Micro-Interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Android & Mobile Sticky Add to Bag Observer
  initMobileStickyBar();

  // 2. Free Shipping Progress Meter Dynamic Calculation
  initFreeShippingMeter();

  // 3. Header Glassmorphic Elevation on Scroll
  initHeaderElevation();
});

/**
 * Mobile Sticky Add To Bag Bar
 * Activates when main product button scrolls out of view on Android/iOS
 */
function initMobileStickyBar() {
  const mainAtc = document.querySelector('.m-product-form__submit, [name="add"], .m-buy-buttons__atc');
  const stickyBar = document.querySelector('.bmb-mobile-sticky-atc');

  if (!mainAtc || !stickyBar) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }, {
    rootMargin: '-50px 0px 0px 0px',
    threshold: 0
  });

  observer.observe(mainAtc);

  // Bind Sticky Button Click to Trigger Main Form Submission
  const stickyBtn = stickyBar.querySelector('.bmb-mobile-sticky-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      mainAtc.click();
    });
  }
}

/**
 * Cart Drawer Free Shipping Progress Calculator
 * Target: Free White-Glove Delivery at ₹15,000
 */
function initFreeShippingMeter() {
  const FREE_SHIPPING_THRESHOLD = 1500000; // in paisa (₹15,000)

  window.updateBmbShippingMeter = function (cartTotal) {
    const meter = document.querySelector('.bmb-free-shipping-meter');
    if (!meter) return;

    const fillBar = meter.querySelector('.bmb-shipping-bar-fill');
    const statusText = meter.querySelector('.bmb-shipping-status-text');
    if (!fillBar || !statusText) return;

    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      fillBar.style.width = '100%';
      statusText.innerHTML = '✨ <strong>Congratulations!</strong> You have unlocked Complimentary Express Delivery.';
    } else {
      const remaining = (FREE_SHIPPING_THRESHOLD - cartTotal) / 100;
      const progress = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
      fillBar.style.width = progress + '%';
      statusText.innerHTML = `Add <strong>₹${remaining.toLocaleString('en-IN')}</strong> more for Complimentary Express Delivery.`;
    }
  };
}

/**
 * Header Elevation on Scroll
 */
function initHeaderElevation() {
  const header = document.querySelector('.m-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }, { passive: true });
}
